import { Ref } from 'vue';
import { QuoteStore, QuoteStoreInterface } from '@/quote/infrastructure/store/QuoteStore';
import { usePlocState, getStore } from '@hfc/ui-core';

interface UseQuoteStoreInterface {
  quoteStore: QuoteStore;
  quoteState: Ref<QuoteStoreInterface>;
}

export const useQuoteStore = (): UseQuoteStoreInterface => {
  const quoteStore = getStore<QuoteStore>('QuoteStore', QuoteStore);
  const quoteState = usePlocState(quoteStore) as Ref<QuoteStoreInterface>;

  return {
    quoteStore,
    quoteState,
  };
};
